<template>
    <div
        class="Answer"
        :class="{
            'Answer--desktop': desktop,
            'Answer--big': big,
            'Answer--selected': selected,
            'Answer--antifouling': antifouling,

        }"
        @mousedown.prevent="selectAnswer"
        oncontextmenu="return false"
    >
        <template v-if="antifouling">
            <div class="Answer-antifoulingWrapper">
                <div class="Answer-inputRadio"/>
                <img
                    class="Answer-productImage"
                    :src="imageSrc"
                    @error="imageError">
            </div>
            <div
                v-multiline-answer
                class="Answer-labelWrapper">
                <span
                    v-if="sublabel"
                    class="Answer-labelSub">{{ translatePosition(sublabel) }}</span>
                <span class="Answer-label">{{ label }}</span>
            </div>
        </template>
        <template v-else>
            <div class="Answer-inputRadio"/>
            <div class="Answer-bigWrapper">
                <div class="Answer-labelWrapper">
                    <span class="Answer-label">{{ label }}</span>
                    <span
                        v-if="sublabel"
                        class="Answer-labelSub">{{ sublabel }}</span>
                </div>
                <hempel-icon
                    v-if="icon"
                    :name="icon"
                    :desktop="desktop"/>
            </div>
        </template>
    </div>
</template>
<script>
import HempelIcon from '@/components/shared/icon/Icon'

export default {
    name: 'HempelAnswer',
    data() {
        return {
            imageLoadFailed: false
        }
    },
    computed: {
        imageSrc() {
            return (!this.imageLoadFailed && this.image) || '/images/placeholder.png'
        },
        localProduct() {
            return this.getProducts.filter(product => product.productId === this.value).pop()
        }
    },
    props: {
        label: {
            type: String,
            required: true
        },
        value: {
            type: [Number, String]
        },
        selected: {
            type: Boolean,
            default: false
        },
        sublabel: {
            type: String,
            default: null
        },
        icon: {
            type: String,
            default: null
        },
        desktop: {
            type: Boolean,
            default: false
        },
        big: {
            type: Boolean,
            default: false
        },
        antifouling: {
            type: Boolean,
            default: false
        },
        image: {
            type: String,
            default: null
        }
    },
    components: {
        HempelIcon
    },
    methods: {
        imageError() {
            this.imageLoadFailed = true
        },
        selectAnswer() {
            this.$emit('input', {
                value: this.value
            })
        },
        translatePosition(position) {
            return position !== 'best-buy'
                ? this.translation.calculate.result.category[`${position}`]
                : this.translation.calculate.result.category.bestBuy
        }
    }
}
</script>
